import React from 'react';
import SidebarItem from './SidebarItem';
import { Context } from '../../config/store';
import admin from './admin';
import affiliate from './affiliate';
// import dsa from './dsa';
const Sidebar = () => {
	const { state, dispatch } = React.useContext(Context);
	const [open, setOpenState] = React.useState(false);
	const [showIconOnly, setShowIconOnly] = React.useState(false)
	const items = {
		admin,
		affiliate,
		lender: affiliate,
		// dsa
	};
	const checkHasPermission = (sidebarMenu) => {
		// if (state.is_super_admin === 1) return sidebarMenu;
		const permission = (state.permission || []).find(
			(permission) => (sidebarMenu.permission || '').split(',').includes(permission)
		);

		if (permission) return sidebarMenu;
		else return false;
	};
	return (
		<nav className='sidebar'>
			<ul className='nav flex-column' id='nav_accordion'>
				<label
					htmlFor='handler'
					className='handler'
					onClick={() => {
						setShowIconOnly(!showIconOnly)
						setOpenState(!open)
						dispatch({
							type: 'sidebarOpen',
							sidebarOpen: open,
						})
					}}
				>
					{open ? (
						<i className='fa fa-chevron-right'></i>
					) : (
						<i className='fa fa-chevron-left'></i>
					)}
				</label>
				{items[state.userType]
					.filter((sidebarMenu) =>
						sidebarMenu.permission
							? checkHasPermission(sidebarMenu)
							: sidebarMenu
					)
					.map((sidebarItem, index) => (
						<SidebarItem {...sidebarItem} key={sidebarItem.id} showIconOnly={showIconOnly} />
					))}
			</ul>
		</nav>
	);
};

export default Sidebar;
